import * as XLSX from "xlsx";
const downloadAsExcel = (args) => {
  let dataPoints = [[]],
    filename;
  filename = args.filename || "chart-data";
  for (let i = 0; i < args.chart.datasets[0].data.length; i++) {
    dataPoints[i] = args.chart.datasets.map((item, index) => {
      return item.data[i].y;
    });
    dataPoints[i].push(args.chart.datasets[0].data[0].x.toISOString());
  }
  dataPoints.unshift(args.chart.datasets.map((item) => item.label));
  let ws = XLSX.utils.aoa_to_sheet(dataPoints);
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + ".xlsx");
};

const Aux = (p) => p.children;

const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export { downloadAsExcel, Aux, nFormatter };
